import { Typography } from '@sunwebgroup/ui-components/uds'
import styles from './ReviewScore.module.css'

interface ReviewScoreProps {
  rating: number
  scoreLabel: string
}

export function ReviewScore({ rating, scoreLabel }: ReviewScoreProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.ratingBubble}>
        <Typography variant="body-s-bold-flat">{rating}</Typography>
      </div>
      <Typography variant="body-m-bold-tight">{scoreLabel}</Typography>
    </div>
  )
}
